export default "__VITE_ASSET__b4b45998__"